export const Global = {} as const;

export const DiscountModes = {
  NET_DISCOUNT: 0,
  PERCENTAGE: 1,
} as const;

/**
 * Default coordinates used for Google Places location bias
 * when the user's geolocation is unavailable.
 */
export const LatLngObj = {
  lat: 29.006029,
  lng: -82.332887,
} as const;

export const SiteText = {
  TECHNICAL_ERROR: 'Sorry! There is a technical issue. Please try again later.',
  SESSION_ERROR: 'Your session has expired. Please sign in again.',
  EMPTY_RECORDS: 'No records found.',
  NO_RECIPES: 'No recipes found.',
  SELECT_RATING: 'Please provide a rating for at least one meal.',
  PAYMENT_ERROR: 'Payment failed. Please try another payment method.',
  CARD_UPDATE_ERROR:
    'Sorry! There is an issue updating your card. Please try another payment method.',
  PAYMENT_PROCESSING:
    'Payment processing. Please reach out to admin for more info.',
  CARD_UPDATE_PROCESSING:
    'Your card update is still processing. Please reach out to admin for more info.',
} as const;
